import { ColorSchemeProvider } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTernaryDarkMode } from 'usehooks-ts';

import theme from '~/styles/theme.json';

export type IPersistentColorSchemeProviderProps = {
  children: React.ReactNode;
};

export const PersistentColorSchemeProvider: React.FC<
  IPersistentColorSchemeProviderProps
> = (props) => {
  const { children } = props;
  const { isDarkMode } = useTernaryDarkMode();

  // TODO: find a more elgant way to get the correct background color role
  // (surfaceContainerLow) from the theme.
  const backgroundColor = isDarkMode
    ? theme.schemes.dark.surfaceContainerLow
    : theme.schemes.light.surfaceContainerLow;

  return (
    <ColorSchemeProvider variant={isDarkMode ? 'dark' : 'light'}>
      <Helmet>
        <style type="text/css">{`
            body {
              background-color: ${backgroundColor};
            }
          `}</style>
      </Helmet>
      {children}
    </ColorSchemeProvider>
  );
};
